// extracted by mini-css-extract-plugin
export var box = "_4m-1";
export var checked = "_4m-2";
export var descriptionSpacer = "_4m-9";
export var disabled = "_4m-3";
export var icon = "_4m-6";
export var input = "_4m-0";
export var labelSpacer = "_4m-8";
export var medium = "_4m-5";
export var small = "_4m-4";
export var text = "_4m-7";